import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    SG_GET_REPORTS,
    UPDATE_REPORT_PAGE_NUMBER,
} from 'constants/actions';
import PageIntro from '../components/PageIntro';

export default function Index() {
    const dispatch = useDispatch();
    const { reports, pageNumber } = useSelector(
        (s) => ({
            reports: s.action_report?.reports || [],
            pageNumber: s.action_report?.pageNumber || 1,
        }),
        shallowEqual
    );

    const [page, setPage] = useState(pageNumber);

    console.log('Render Index', { reports, pageNumber, page });

    useEffect(() => {
        const query = `page=${page}`;
        dispatch({ type: SG_GET_REPORTS, payload: query });
        dispatch({ type: UPDATE_REPORT_PAGE_NUMBER, payload: page });
    }, [dispatch, page]);

    const list = Array.isArray(reports) ? reports : reports?.results || [];
    const total = Array.isArray(reports) ? list.length : reports?.count || list.length;
    const hasNext = !Array.isArray(reports) ? Boolean(reports?.next) : false;

    const fmtDate = (d) => (d ? new Date(d).toLocaleString() : '-');

    return (
        <div>
            <PageIntro
                title="Reports"
                description="Reports are generated from completed surveys and delivered to managers. They are the source for manager-facing insights used in planning events."
                bullets={[
                    'Where data comes from: generated from debrief/survey results via background jobs.',
                    'What to expect: a report document (PDF), approval workflow, and scheduled send dates.',
                    'Next steps: review, approve or regenerate reports; schedule send date if required.'
                ]}
            />

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {list.length ? (
                    list.map((r) => {
                        const statusColor = r.status === 'sent' ? '#1b9e77' : (r.status === 'generated' ? '#0b5fff' : (r.status === 'failed' ? '#d64545' : '#f59e0b'));
                        return (
                            <div key={r.id} style={{ padding: 12, border: '1px solid #eee', borderRadius: 8, background: '#fff', display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center' }}>
                                    <div style={{ minWidth: 0 }}>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'baseline', minWidth: 0 }}>
                                            <div style={{ fontWeight: 700, fontSize: 15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.name || r.title || r.report_name || 'Report'}</div>
                                            <div style={{ color: '#999', fontSize: 12, whiteSpace: 'nowrap' }}>{r.language?.toUpperCase() || ''}</div>
                                        </div>
                                        <div style={{ color: '#777', fontSize: 12, marginTop: 6 }}>{r.organization?.name || r.organization_name || '-'} <span style={{ color: '#999', marginLeft: 8 }}>Org id: {r.organization?.id ?? '-'}</span></div>
                                        <div style={{ color: '#999', fontSize: 11, marginTop: 6 }}>Report id: {r.id} • tracking: {r.tracking_code}</div>
                                    </div>

                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                        <div style={{ padding: '6px 10px', borderRadius: 999, background: '#fff', border: `1px solid ${statusColor}`, color: statusColor, fontWeight: 700, fontSize: 12 }}>{r.status}</div>
                                        <div style={{ textAlign: 'right', color: '#666', fontSize: 12 }}>
                                            <div>{r.manager?.first_name} {r.manager?.last_name} <small style={{ color: '#999' }}>#{r.manager?.id ?? '-'}</small></div>
                                            <div style={{ fontSize: 11 }}>{r.manager?.email}</div>
                                        </div>
                                        {r.id && r.id !== 'undefined' ? (
                                            <Link to={`/app/action/reports/details/${r.id}`} style={{ marginLeft: 12, color: '#0b5fff', fontWeight: 700 }}>View</Link>
                                        ) : (
                                            <span style={{ color: '#9ca3af', marginLeft: 12 }}>No id</span>
                                        )}
                                    </div>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <div style={{ color: '#666', fontSize: 13 }}>Campaign: <strong style={{ marginLeft: 6 }}>{r.campaign_name || '-'}</strong></div>
                                    <div style={{ display: 'flex', gap: 10, alignItems: 'center', color: '#666', fontSize: 12 }}>
                                        <div>Generated: {fmtDate(r.generation_started_at || r.generation_completed_at || r.created_at)}</div>
                                        <div>| Sent: {fmtDate(r.sent_at)}</div>
                                        <div>| Review deadline: {fmtDate(r.reviewed_at || r.report_review_deadline)}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div style={{ padding: 18, border: '1px dashed #eee', borderRadius: 8, color: '#666' }}>No reports</div>
                )}
            </div>

            <div style={{ marginTop: 12 }}>
                <button onClick={() => setPage(Math.max(1, page - 1))} disabled={page === 1}>Previous</button>
                <span style={{ margin: '0 12px' }}>Page {page} — {total} items</span>
                <button onClick={() => setPage(page + 1)} disabled={!hasNext}>Next</button>
            </div>
        </div>
    );
}
